"use client"

import { LoadDialog } from "@/components/common/Load"
import { createContext, useContext, useMemo, useState, PropsWithChildren, useCallback, useEffect } from "react"

export const globalLoading = {
    show: () => { },
    hide: () => { },
}

type LoadingContextValue = {
    isOpen: boolean
    show: () => void
    hide: () => void
}

const LoadingContext = createContext<LoadingContextValue | null>(null)

export function LoadingProvider({ children }: PropsWithChildren) {
    const [isOpen, setIsOpen] = useState(false)

    const show = useCallback(() => setIsOpen(true), [])
    const hide = useCallback(() => setIsOpen(false), [])

    useEffect(() => {
        globalLoading.show = show
        globalLoading.hide = hide
    }, [show, hide])

    const value = useMemo(
        () => ({
            isOpen,
            show,
            hide,
        }),
        [isOpen, show, hide],
    )

    return (
        <LoadingContext.Provider data-component-id="src/core/providers/loading.provider.tsx:40:8" data-component-path="src/core/providers/loading.provider.tsx" data-component-line="40" data-component-end-line="43" data-component-file="loading.provider.tsx" data-component-name="LoadingContext.Provider" data-component-content="%7B%22elementName%22%3A%22LoadingContext.Provider%22%2C%22value%22%3A%22%5Bvar%3Avalue%5D%22%7D" value={value}>
            {children}
            <LoadDialog data-component-id="src/core/providers/loading.provider.tsx:42:12" data-component-path="src/core/providers/loading.provider.tsx" data-component-line="42" data-component-end-line="42" data-component-file="loading.provider.tsx" data-component-name="LoadDialog" data-component-content="%7B%22elementName%22%3A%22LoadDialog%22%7D" isOpen={isOpen} />
        </LoadingContext.Provider>
    )
}

export function useLoading() {
    const ctx = useContext(LoadingContext)
    if (!ctx) {
        throw new Error("useLoading must be used within LoadingProvider")
    }
    return ctx
}
